export default __webpack_public_path__ + "static/media/empty.c8301e2a.svg";